module.exports = __webpack_public_path__ + "images/d395e75.png";